var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-avatar",style:(_vm.style_avatar)},[(_vm.image)?_c('div',{staticClass:"menu-image",style:(_vm.style)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }